/* eslint-disable camelcase */ 

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_embrace_balanced_approach_to_wellness_addressing_physical_mental_emotional_and_spiritual_for: Phrase =locale => {
  const en = `Embrace a balanced approach to wellness, addressing physical, mental, emotional, and spiritual dimensions for holistic health and happiness.`;
  const phrases: { [key: string]: undefined | string } = {
    en, 
    es: `Adopta un enfoque integral de tu bienestar físico, mental, emocional y espiritual para alcanzar una salud óptima.`,
  };
  return phrases[locale] || en;
};
            